/** One thumbnail next to the "+N" tile; with a single slot the row would be just "+N". */
export const MIN_THUMBNAIL_SLOTS = 2;
